import React from "react";

const Screen = (props) => {
    const { component, callback = () => {}, closable = false, title = "" } = props;

    return (
        <div className="ui-screen">
            {closable && (
                <div className="ui-screen-header">
                    <span>{title}</span>
                    <button onClick={() => callback(null)}> × </button>
                </div>
            )}
            <div className="ui-screen-content">
                {React.isValidElement(component) ? React.cloneElement(component, { callback }) : null}
            </div>
        </div>
    );
};

export default Screen;